module.exports = __webpack_public_path__ + "static/media/deloitte_logo.0ba79cd2.png";